export const FLAG_GETTING_DELIVERIES = 'FLAG_GETTING_DELIVERIES';
export const GET_DELIVERIES = 'GET_DELIVERIES';
export const CLEAR_DELIVERIES = 'CLEAR_DELIVERIES';
export const FLAG_DELIVERY_ACTIVITY = 'FLAG_DELIVERY_ACTIVITY';
export const GET_DELIVERY = 'GET_DELIVERY';
export const CLEAR_DELIVERY = 'CLEAR_DELIVERY';
export const OPEN_MODAL = 'OPEN_MODAL';
export const FLAG_YANGO_DELIVERY_ACTIVITY = 'FLAG_YANGO_DELIVERY_ACTIVITY';
export const GET_YANGO_PRICE = 'GET_YANGO_PRICE';
export const CLEAR_YANGO_PRICE = 'CLEAR_YANGO_PRICE';
export const GET_YANGO_CLAIM = 'GET_YANGO_CLAIM';
export const GET_YANGO_CANCELATION_INFO = 'GET_YANGO_CANCELATION_INFO';
export const CLEAR_YANGO_CANCELATION_INFO = 'CLEAR_YANGO_CANCELATION_INFO';
